var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatercut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 807,
    viewBox: "0 0 526 807",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.5 684L138.5 713.5",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 254H67V435H210V254Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201 184H76V254H201V184Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 130H100V184H177V130Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 56V2H57V56H220Z",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 56H36V130H241V56Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 184H107V254H170V184Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 435H67V470H210V435Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 435H67V470H210V435Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 576H1V602H276V576Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 523H117L67 470H210L160 523Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 523H117V576H160V523Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 602H117V623H160V602Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 684H126L117 623H160L151 684Z",
    fill: "#AD2926",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 219V247H488.5C479.615 247 471.094 250.529 464.812 256.812C458.529 263.094 455 271.615 455 280.5V461.5C455.001 469.577 453.411 477.574 450.321 485.037C447.231 492.499 442.701 499.279 436.99 504.99C431.279 510.701 424.499 515.231 417.037 518.321C409.574 521.411 401.577 523.001 393.5 523C385.423 523.001 377.426 521.411 369.963 518.321C362.501 515.231 355.721 510.701 350.01 504.99C344.299 499.279 339.769 492.499 336.679 485.037C333.589 477.574 331.999 469.577 332 461.5V377.5C332 368.615 328.471 360.094 322.188 353.812C315.906 347.529 307.385 344 298.5 344H263V316H298.5C306.577 315.999 314.574 317.589 322.037 320.679C329.499 323.769 336.279 328.299 341.99 334.01C347.701 339.721 352.231 346.501 355.321 353.963C358.411 361.426 360.001 369.423 360 377.5V461.5C360 470.385 363.529 478.906 369.812 485.188C376.094 491.471 384.615 495 393.5 495C402.385 495 410.906 491.471 417.188 485.188C423.471 478.906 427 470.385 427 461.5V280.5C426.999 272.423 428.589 264.426 431.679 256.963C434.769 249.501 439.299 242.721 445.01 237.01C450.721 231.299 457.501 226.769 464.963 223.679C472.426 220.589 480.423 218.999 488.5 219L528 219Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 120C61.5228 120 66 115.523 66 110C66 104.477 61.5228 100 56 100C50.4772 100 46 104.477 46 110C46 115.523 50.4772 120 56 120Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 120C225.523 120 230 115.523 230 110C230 104.477 225.523 100 220 100C214.477 100 210 104.477 210 110C210 115.523 214.477 120 220 120Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 303V357H194C186.839 357 179.972 354.155 174.908 349.092C169.845 344.028 167 337.161 167 330C167 322.839 169.845 315.972 174.908 310.908C179.972 305.845 186.839 303 194 303H266Z",
    fill: "white",
    stroke: "#282828",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 806.04H138.085C134.172 806.04 131 802.868 131 798.955V798.955C131 795.042 134.172 791.87 138.085 791.87H180.6C184.516 791.87 187.69 788.696 187.69 784.78V784.78C187.69 780.864 184.516 777.69 180.6 777.69H138.085C134.172 777.69 131 774.518 131 770.605V770.605C131 766.692 134.172 763.52 138.085 763.52H180.605C184.518 763.52 187.69 760.348 187.69 756.435V756.435C187.69 752.522 184.518 749.35 180.605 749.35H138.09C134.174 749.35 131 746.176 131 742.26V742.26C131 738.344 134.174 735.17 138.09 735.17H180.605C184.518 735.17 187.69 731.998 187.69 728.085V728.085C187.69 724.172 184.518 721 180.605 721H138.09",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 526,
    height: 807,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatercut);
export default __webpack_public_path__ + "static/media/watercut.fd5cb9c14d7b2a95f9c2f13ea4faa5c5.svg";
export { ForwardRef as ReactComponent };